import uniqBy from 'lodash/uniqBy';
import { ADD_TENANTS } from '@/store/modules/tenant/mutation_types';
import { MUTATE, MUTATE_MULTIPLE } from '@/store/modules/mutation_types';
import { mutate, mutateMultiple } from '@/store/modules/mutations';

export default {
  [MUTATE]: mutate,
  [MUTATE_MULTIPLE]: mutateMultiple,
  [ADD_TENANTS](state, tenants) {
    const tenantsMapped = tenants.map(tenant => {
      return {
        id: tenant.id,
        data: tenant.data(),
      };
    });

    state.tenants = uniqBy([...tenantsMapped, ...state.tenants], (tenant) => {
      return tenant.id;
    });
  },
};
